<template>
  <div class="line-chart">
    <v-skeleton v-if="loading" width="100%" height="100%" />
    <LineChart
      v-else
      :chart-id="chartId"
      :chart-data="chartData"
      :chart-options="chartOptions"
      :styles="wrapperStyles"
    />
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import VSkeleton from '@/components/v3/elements/VSkeleton';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend);

const SERIES_COLORS = ['#4D7CFE', '#6C7995'];

export default {
  name: 'VLineChart',
  components: { LineChart: Line, VSkeleton },
  props: {
    chartId: {
      type: String,
      default: 'line-chart',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    labels: {
      type: Array,
      default: () => [],
    },
    datasets: {
      type: Array,
      default: () => [],
    },
    colors: {
      type: Array,
      default: () => SERIES_COLORS,
    },
    valueFormatter: {
      type: Function,
      default: value => value,
    },
  },
  computed: {
    wrapperStyles() {
      return { position: 'relative', width: '100%', height: '100%' };
    },
    chartData() {
      return {
        labels: this.labels,
        datasets: this.datasets.map((dataset, index) => {
          const color = dataset.color || this.colors[index];
          return {
            label: dataset.label,
            data: dataset.data,
            borderColor: color,
            backgroundColor: color,
            borderWidth: 2,
            pointRadius: 3,
            pointHoverRadius: 5,
            pointBackgroundColor: '#ffffff',
            pointBorderColor: color,
            pointBorderWidth: 2,
            tension: 0.3,
            fill: false,
          };
        }),
      };
    },
    chartOptions() {
      const format = this.valueFormatter;
      return {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        plugins: {
          legend: {
            position: 'top',
            align: 'end',
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              boxWidth: 14,
              padding: 14,
              color: '#6C7995',
              font: { size: 12 },
            },
          },
          tooltip: {
            callbacks: {
              label(context) {
                return ` ${context.dataset.label}: ${format(context.parsed.y)}`;
              },
            },
          },
        },
        scales: {
          x: {
            grid: { display: false, drawBorder: false },
            ticks: { color: '#6C7995', font: { size: 11 } },
          },
          y: {
            beginAtZero: true,
            grid: { color: '#E1E5ED', drawBorder: false },
            ticks: {
              color: '#6C7995',
              font: { size: 11 },
              callback: value => format(value),
            },
          },
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.line-chart {
  position: relative;
  width: 100%;
  height: 280px;
}
</style>
